<template>
  <a-date-picker
    :open=open
    :value="year"
    mode="year"
    v-bind="$attrs"
    format="YYYY"
    @openChange="handleOpenChange"
    @panelChange="handlePanelChange"
    @change="clearValue"></a-date-picker>
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'ptYearPicker',
    props:{
      value:{
        default:undefined
      }
    },
    data(){
      return {
        open:false,
        year:this.value,
      }
    },
    mounted() {
      if(this.value){
        this.year = moment(this.value)
      }
    },
    watch:{
      value(newValue){
        this.year = moment(newValue)
      }
    },
    methods:{
      handlePanelChange (value){
        this.$emit('input',value)
        this.year = value
        this.$emit('yearChange',value)
        this.open = false
      },
      handleOpenChange (status) {
        // console.log(status)
        if(status){
          this.open = true
        } else {
          this.open = false
        }
      },
      clearValue () {
        this.year = undefined
        this.$emit('yearChange',undefined)
        this.$emit('input',undefined)
      }
    }
  }
</script>

<style scoped>

</style>